import { mapRecord, memo } from '@morphic-ts/common/es6/utils';
import { showApplyConfig } from '../config';
import { ShowType, ShowURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const showTaggedUnionInterpreter = memo(() => ({
    _F: ShowURI,
    taggedUnion: (tag, types, _name, config) => env => {
        const shows = mapRecord(types, a => a(env).show.show);
        return new ShowType(showApplyConfig(config)({
            show: (a) => shows[a[tag]](a)
        }, env, {}));
    }
}));
